import Cookies from "universal-cookie";
import axios from "axios";
import config from "~/config";
import { getAccessToken } from "~/redux/helpers/user";

const cookies = new Cookies(window.document.cookie);

export const storeWalkthroughRespone =
  (featureWalk, videoWalked) => async (dispatch) => {
    try {
      const accessToken = await getAccessToken();
      if (accessToken) {
        const response = await axios({
          url: `${config.base_url}/api/updateVideoAndFeatureWalkthroughKey`,
          method: "POST",
          data: JSON.stringify({
            Pbu: cookies.get("portbu") || "",
            Oeid: cookies.get("oeid") || "",
            IsFeatureWalked: featureWalk,
            IsVideoWalked: videoWalked,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `${accessToken}`,
          },
        });
        const responseBody = response.data;
        if (!responseBody.error) {
          dispatch({
            type: "SUCCESS_UPDATION_VIDEO_PLAY",
            payload: responseBody,
          });
          return true;
        }
      }
    } catch (error) {
      dispatch({
        type: "FAILED_UPDATION_VIDEO_PLAY",
        payload: error.message || "An error has occured.",
      });
      return false;
    }
  };
